import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'on-account-form',
    templateUrl: './account-form.component.html',
    styleUrls: ['./account-form.component.scss'],
})
export class AccountFormComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
